export default "__VITE_ASSET__D9yRdV5E__"